import { jsx as u } from "react/jsx-runtime";
import * as S from "./index.es591.js";
import _ from "classnames";
import { kebabCase as w } from "lodash/fp";
import { forwardRef as D, useMemo as i, useState as A, useCallback as x } from "react";
import * as L from "./index.es592.js";
import { ICONS_DESCRIPTION as P } from "./index.es593.js";
import b from "./index.es594.js";
import { getIconName as R } from "./index.es595.js";
import { IconContext as j } from "./index.es596.js";
import { createDynamicIcon as H } from "./index.es597.js";
import { IconContainer as K } from "./index.es148.js";
import { onKeyDownEnter as U } from "./index.es500.js";
const $ = "icon-component", F = {
  warning: "var(--plac-icon-warning)",
  success: "var(--plac-icon-success)",
  error: "var(--plac-icon-error)",
  gray: "var(--plac-icon-gray-default)",
  brand: "var(--plac-icon-brand-default)",
  white: "var(--plac-icon-white)",
  "brand-hover": "var(--plac-icon-brand-hover)",
  "gray-hover": "var(--plac-icon-gray-hover)"
}, q = Object.entries(L).reduce(
  (a, [r, c]) => (a[r] = H({
    displayName: r,
    duotoneComponent: c
  }), a),
  {}
), z = { ...S, ...q }, B = D(
  ({
    type: a,
    color: r = "gray",
    size: c = 18,
    disabled: s,
    allowHoverState: m = !0,
    testId: g = $,
    weight: p = "duotone",
    onClick: t,
    onMouseEnter: e,
    onMouseLeave: n,
    ...h
  }, O) => {
    const d = R(a), T = _(b.icon, { [b.disabled]: s }), y = i(
      () => z[d],
      [d]
    ), [f, C] = A(!1), l = i(
      () => (r === "brand" || r === "gray") && m,
      [m, r]
    ), N = i(
      () => s ? "var(--plac-icon-disabled)" : F[`${r}${f ? "-hover" : ""}`],
      [r, s, f]
    ), v = x(
      (o, I) => {
        l && (I ? e == null || e(o) : n == null || n(o), C(I));
      },
      [e, n, l]
    );
    return /* @__PURE__ */ u(
      j.Provider,
      {
        value: {
          color: N,
          size: c,
          weight: p === "outline" ? "regular" : p,
          ref: O,
          alt: a,
          onMouseEnter: (o) => v(o, !0),
          onMouseLeave: (o) => v(o, !1),
          onKeyDown: (o) => U(o, () => t == null ? void 0 : t()),
          onClick: t,
          className: T,
          "aria-label": P[w(a)],
          cursor: t ? "pointer" : "default",
          role: t ? "button" : void 0,
          ...h
        },
        children: /* @__PURE__ */ u(y, { "data-testid": g })
      }
    );
  }
), E = B;
E.IconContainer = K;
export {
  $ as ICON_DEFAULT_TESTID,
  E as Icon
};
//# sourceMappingURL=index.es147.js.map
